import defaultClient from '@src/api/clients/default';

const URL = (path = '') => {
    return `dashboard/clients/${path}`; // Ensure the correct path here
  };
  

export function fetchClients() {
  return defaultClient.request({
    url: URL(''), // This will correctly hit /api/clients/
  });
}
